export default __webpack_public_path__ + "0b8baeb041f9678bcba5e25843c35563.png";